// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_to-0";